import React, { useState } from 'react';
import ReactDOM from 'react-dom';

import './ResponseModal.css';

const ResponseModal = (props) => {
  const [pop, setPop] = useState('pop__up');
  return ReactDOM.createPortal(
    <div className='responseModal'>
      <div className={`responseModal__container ${pop}`}>
        <div className='responseModal__message'>We will contact you soon!</div>
        <div
          className='button'
          onClick={() => {
            setPop('pop__down');
            setTimeout(() => {
              props.setOpen();
            }, 500);
          }}>
          Okay
        </div>
      </div>
    </div>,
    document.getElementById('responsePortal')
  );
};

export default ResponseModal;
